import { EMPTY_LIST } from '../../../../constants/common'
import { GretaAIChatProjectsPageCard } from '../GretaAIChatProjectsPageCard'

import * as styles from './GretaAIChatProjectsPageGrid.module.css'

function GretaAIChatProjectsPageGrid({ locale, now, projects = EMPTY_LIST }) {
  return (
    <ul className={styles.grid}>
      {projects.map(project => (
        <GretaAIChatProjectsPageCard
          key={project.id}
          locale={locale}
          now={now}
          project={project}
        />
      ))}
    </ul>
  )
}

export default GretaAIChatProjectsPageGrid
